import { Formik, FormikHelpers } from "formik";
import { useEffect, useState } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import ReactQuill from "react-quill";
import * as Yup from "yup";
import GlobalSettingsApi from "../../../api/GlobalSettingsApi";
import { QuillModules } from "../../../config/app-constants";
import { EToastvariant, ICookiesPolicyForm, IGlobalSettings } from "../../../config/interfaces";
import { useAppDispatch } from "../../../redux/Store";
import { showToastMsg } from "../../../redux/slice/ToastMsgSlice";
import { UtilService } from "../../../services";
import { ButtonSpinner } from "../../placeholders";

// Validation Schema of Cookies and Pollicy
const cookiesPolicySchema = Yup.object().shape({
  cookies_policy: Yup.string().trim().required("This field is required")
});

const CookiesPolicy = () => {
  const dispatch = useAppDispatch();
  const [cookiesPolicyData, setCookiesPolicyData] = useState<IGlobalSettings>();

  useEffect(() => {
    getCookiesPolicy();
  }, []);

  // Get CookiesPolicy Value
  const getCookiesPolicy = async () => {
    try {
      const api = GlobalSettingsApi.getInstance();
      const response = await api.getGlobalSettingByKey("COOKIES_POLICY");
      setCookiesPolicyData(response?.data);
    } catch (error) {
      dispatch(
        showToastMsg({
          isVisible: true,
          title: "Error",
          message: UtilService.getErrorMessage(error),
          variant: EToastvariant.Danger
        })
      );
    }
  };

  const initialCookiesPolicyFormValues: ICookiesPolicyForm = {
    cookies_policy: cookiesPolicyData?.value || ""
  };

  const handleCookiesPolicyFormSubmit = async (
    values: { cookies_policy: string },
    { setSubmitting }: FormikHelpers<any>
  ): Promise<void> => {
    try {
      const api = GlobalSettingsApi.getInstance();
      const _values: any = {
        value: values.cookies_policy
      };
      let _msg = `Cookies policy added successfully.`;

      if (cookiesPolicyData?.uuid) {
        await api.updateGlobalSettings(cookiesPolicyData?.uuid, _values);
        _msg = `Cookies policy updated successfully.`;
      } else {
        _values.key = "COOKIES_POLICY";
        await api.createGlobalSettings(_values);
      }
      dispatch(
        showToastMsg({
          isVisible: true,
          title: "Success",
          message: _msg,
          variant: EToastvariant.Success
        })
      );
      // dispatch(fetchGlobalSettings());
    } catch (error) {
      dispatch(
        showToastMsg({
          isVisible: true,
          title: "Error",
          message: UtilService.getErrorMessage(error),
          variant: EToastvariant.Danger
        })
      );
    } finally {
      setSubmitting(false);
    }
  };
  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={initialCookiesPolicyFormValues}
        validationSchema={cookiesPolicySchema}
        onSubmit={handleCookiesPolicyFormSubmit}
      >
        {({ handleSubmit, isSubmitting, handleChange, values }) => (
          <>
            <Card className="form-card tab-card">
              <Card.Body>
                <Row>
                  <Col>
                    <Form.Group className="form-group" controlId="cookies_policy">
                      <ReactQuill
                        theme="snow"
                        modules={QuillModules}
                        value={values.cookies_policy}
                        onChange={handleChange("cookies_policy")}
                        placeholder="Enter cookies policy"
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <div className="form-btns-wrap">
                  <Button
                    variant="primary"
                    type="button"
                    size="lg"
                    className="btn-w-160 text-white"
                    onClick={() => handleSubmit()}
                  >
                    {!isSubmitting ? "Save" : <ButtonSpinner />}
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </>
        )}
      </Formik>
    </>
  );
};

export default CookiesPolicy;
